"use strict";
import { jsx } from "react/jsx-runtime";
const Circle = ({
  position,
  fillColor = "rgba(0,0,0,0)",
  lineColor = "rgba(0,0,0,0)",
  lineWidth = 0
}) => {
  return /* @__PURE__ */ jsx(
    "circle",
    {
      cx: position.center.x,
      cy: position.center.y,
      r: position.radius,
      strokeWidth: lineWidth,
      stroke: lineWidth > 0 ? lineColor : "none",
      fill: fillColor
    }
  );
};
export default Circle;
